import { render, staticRenderFns } from "./woodfishSetting.vue?vue&type=template&id=dc9934b8&scoped=true&"
import script from "./woodfishSetting.vue?vue&type=script&lang=js&"
export * from "./woodfishSetting.vue?vue&type=script&lang=js&"
import style0 from "./woodfishSetting.vue?vue&type=style&index=0&id=dc9934b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9934b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc9934b8')) {
      api.createRecord('dc9934b8', component.options)
    } else {
      api.reload('dc9934b8', component.options)
    }
    module.hot.accept("./woodfishSetting.vue?vue&type=template&id=dc9934b8&scoped=true&", function () {
      api.rerender('dc9934b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/woodfishSetting.vue"
export default component.exports